import { styled } from '@mui/joy';

import { externalQuoteTheme } from 'external-quote/styles';

export const PageContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  backgroundColor: '#FFFFFF',
});

export const MainContainer = styled('div')({
  display: 'flex',
  flex: 1,
  overflow: 'hidden',
});

export const HeaderContainer = styled('div')({
  backgroundColor: externalQuoteTheme.colors.headerPurple,
  color: externalQuoteTheme.colors.headerText,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '8px 20px',
  height: '48px',
  position: 'relative',
});

export const HeaderLeft = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
});

export const HeaderTitle = styled('div')({
  fontSize: '18px',
  fontWeight: 400,
});

export const SearchBox = styled('div')({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  display: 'flex',
  alignItems: 'center',
  backgroundColor: '#FFFFFF',
  borderRadius: '3px',
  padding: '3px 10px',
  width: '400px',
});

export const SearchIcon = styled('div')({
  marginRight: '8px',
  display: 'flex',
  alignItems: 'center',
});

export const SearchInput = styled('input')({
  background: 'none',
  border: 'none',
  color: '#666666',
  fontSize: '17px',
  flex: 1,
  outline: 'none',

  '&::placeholder': {
    color: '#999999',
  },
});

export const HeaderRight = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: '20px',
});

export const HeaderText = styled('span')({
  fontSize: '17px',
  color: externalQuoteTheme.colors.headerText,
});

export const ContentContainer = styled('div')({
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  overflow: 'hidden',
  backgroundColor: '#FFFFFF',
});
